import React from 'react'
import './Quick_steps.css'
import Common_Title from '../../common_components/common_title/Common_Title'
import { Link } from 'react-router-dom'

const Quick_steps = () => {
    return (
        <>
            <section className="quick_steps_sec">
                <div className='container'>
                    <Common_Title simpleText="Quick Steps " darkText="to Maximising Your Income"  />

                    <div className='row mt-5 mb-3'>
                        <div className='col-lg-4 col-md-6 col-12 mb-lg-0 mb-4'>
                            <div className='stepcard'>
                                <h1 className='noicon'>01</h1>
                                <h6 className='regh6'> Register as a <br/>Partner Associate</h6>
                                <p className='seamp'>Get onboarded instantly with guided support from our Sales Specialists — no complications.</p>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 mb-lg-0 mb-4'>
                            <div className='stepcard'>
                                <h1 className='noicon'>02</h1>
                                <h6 className='regh6'>Grow Your Student  <br></br> Network Globally</h6>
                                <p className='seamp'>Reach learners across India and abroad with continuous assistance from our dedicated Business Units.</p>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 mb-lg-0 mb-4'>
                            <div className='stepcard'>
                                <h1 className='noicon'>03</h1>
                                <h6 className='regh6'>Boost Your <br></br> Earnings with Ease</h6>
                                <p className='seamp'>Enjoy fast, seamless payouts — focus on enrollments, not follow-ups.</p>
                            </div>
                        </div>

                    </div>

                    <div className='becobox'>
                        <div className='row'>
                            <div className='col-lg-9 my-auto'>
                                <p className='letsp'>Let’s work together to  <b>grow your business faster and help you achieve — and exceed — your goals.</b></p>
                            </div>
                            <div className='col-lg-3 text-lg-end text-center'>
                                <Link to={'/registration'}><button className='becobtn'>Become a Partner</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Quick_steps